import React from 'react';
import { Col, ListGroupItem, Row } from 'reactstrap';

export const RealTimeNotificationNotify = ({ data,type,  onRedirectRealTimeNotification, index, removeNotificationAndClose }) => {

    const onNotificationClick = (e) => {
        e.preventDefault();
        onRedirectRealTimeNotification(data, index, type);
    }

    const onCloseHanlder = (e) => {
        e.preventDefault();
        removeNotificationAndClose(index, true);
    }

    return <ListGroupItem key={index}
        className="list-group-item-action">
        <Row className="align-items-center">
            <Col md="11" className="pr-1">
                <a className="list-group-item-action" href="#item" onClick={e => onNotificationClick(e, data)}>
                    <p className="text-sm mb-0">
                        <span className="h5">{data.title}</span>
                        <span>{data.message}</span></p>
                </a>
            </Col>
            <Col md="1" className="pl-0">
                <a href="#delelte" onClick={e => onCloseHanlder(e)}>
                    <i className="ni ni-fat-remove"></i>
                </a>
            </Col>
        </Row>
    </ListGroupItem>;
};